import { useAuthContext } from '../providers/AuthProvider';

export function useUser() {
  const { user, loading, error, refreshUser } = useAuthContext();

  return {
    user,
    loading,
    error,
    refreshUser,
  };
}